import React, { useContext } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #fff;
  padding: 26px 0;
  .items {
    display: flex;
    div {
      flex-grow: 1;
    }
    span,
    a {
      text-decoration: none;
      color: #40403F;
      font: 300 14px Montserrat;
      &:before {
        content: ' > ';
      }
      &:first-child {
        &:before {
          content: '';
        }
      }
      &.back {
        font-weight: 600;
        @media (max-width: 540px) {
          display: none;
        }
        &:before {
          content: ' ';
          background: url(/images/arrow-left.png) center no-repeat;
          width: 15px;
          height: 15px;
          margin-right: 10px;
          display: inline-block;
          background-size: contain;
          vertical-align: middle;
        }
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  strong {
    margin-top: 14px;
    font: italic bold 46px 'Times new roman';
    display: block;
    @media (max-width: 540px) {
      font-size: 30px;
    }
  }
  .content {
    width: 100%;
  }
  .download-especificacoes {
    border: 3px solid #F1A857;
    border-radius: 3px;
    display: flex;
    height: 55px;
    text-decoration: none;
    transition: all 0.3s;
    @media (max-width: 789px) {
      height: auto;
    }
    &:hover {
      background: #F1A857;
      .text {
        color: #fff;
      }
      .icon {
        border-right: 1px solid #CD8226;
      }
    }
    .text {
      height: 100%;
      flex-grow: 1;
      color: #6A6A6A;
      display: flex;
      align-items: center;
      justify-content: center;
      font: 14px Montserrat;
      white-space: nowrap;
      padding: 0 16px;
      @media (max-width: 789px) {
        white-space: initial;
        padding: 5px 10px;
        font-size: 12px;
      }
    }
    .icon {
      display: flex;
      align-items: center;
      min-width: 60px;
      justify-content: center;
      border-right: 1px solid #F1A857;
      @media (max-width: 789px) {
        display: none;
      }
      i {
        width: 24px;
        background: url(/images/streamline-icon-business-contract-approve@140x140@2x.png) center no-repeat;
        height: 24px;
        background-size: contain;
      }
    }
  }
`

const Breadcrumbs = ({title, link, children, download}) => {
  const { language } = useContext(LanguageContext);
  let buttonText = ''
  switch (language) {
    case 'pt-br':
      buttonText = 'Voltar para Página Inicial';
      break;
    case 'en-us':
      buttonText = 'Back to Home';
      break;
    case 'es-es':
      buttonText = 'De vuelta ao inicio';
      break;
    default:
  }
  return (
    <Container id="breadcrumbs">
      <div className={ ['wrapper', download ? 'flex' : ''].join(' ') }>
        <div className="content">
          <div className="items">
            <div>
              { children }
            </div>
            {
              link && (
                <Link to={ link } className="back">{ buttonText }</Link>
              )
            }
          </div>
          <strong>{ title }</strong>
        </div>
        {
          (download && download.data && download.data.botao_download) && (
            <a href={ download.data.arquivo_download.url } rel="noopener noreferrer" className="download-especificacoes" target="_blank">
              <span className="icon">
                <i></i>
              </span>
              <span className="text">
                { download.data.botao_download }
              </span>
            </a>
          )
        }
        
      </div>
    </Container>
  )
}

export default Breadcrumbs;
